import { render, staticRenderFns } from "./DuplicatePhoneModal.vue?vue&type=template&id=5233d584&scoped=true"
import script from "./DuplicatePhoneModal.vue?vue&type=script&lang=js"
export * from "./DuplicatePhoneModal.vue?vue&type=script&lang=js"
import style0 from "./DuplicatePhoneModal.vue?vue&type=style&index=0&id=5233d584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5233d584",
  null
  
)

export default component.exports